import { useEffect, useState } from "react";

// Returns boolean whether window width is small screen or not.
export default function useSmallScreen() {
  const [smallScreen, setSmallScreen] = useState(false);

  useEffect(() => {
    const resizeHandler = () => {
      let resizeTimer;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setPageWidth();
      }, 300);
    };

    // Set page width on init
    setPageWidth();

    window.addEventListener("resize", resizeHandler);

    return () => window.removeEventListener("resize", resizeHandler);
  }, []);

  const setPageWidth = () => {
    const currentScreenSize = window.innerWidth;
    if (typeof window === "undefined" || currentScreenSize > 1024) {
      setSmallScreen(false);
      return false;
    }
    setSmallScreen(true);
  };

  return { smallScreen };
}
